import { get, post } from "./request"
// // ------------------首页-------------------
// // 获取用户信息
export const getUinfo = params => get("shop/home/shopInfo", params)
// // 获取店铺订单数据集合
export const getDatas = params => get("shop/home/getOrderData", params)
// // 获取7天内数据
export const getAweekData = params => get("shop/home/getSmsData", params)
// // 获取首页任务列表
export const getHomeTaskList = params => get("shop/home/getTaskList", params)
// // 获取验证码
export const getCode = data => post("shop/home/sendShopMobile", data)
// // 绑定手机号
export const bindMobile = params => get("shop/home/checkCode", params)
// // 获取短信剩余和使用数量
export const getSmsMsg = params => get("shop/home/getSmsNumber", params)
// // 退出登录
export const getOut = params => get("shop/shop/loginOut", params)
// 获取活动轮播图
export const getActivity = params => get("shop/home/getBanner", params)
// 获取导航栏外链部分
export const getOutLinks = params => get("shop/home/getLinks", params)
// 获取站内消息列表
export const getMessageList = params => get("shop/Home/getNoticeList", params)
// 获取智能营销列表
export const getAjaxOpt = params => get("shop/home/getIntelligentMarketing", params)
// 获取首页滚动数据
export const getScrollData = params => get("shop/home/getRollList", params)
// 提交反馈意见
export const addFeedback = data => post("shop/Home/addFeedback", data)
// 获取站内推送消息
export const getPushMessage = params => get("shop/Home/getPush", params)
// 忽略所有未读消息
export const ignoreMessage = data => post("shop/Home/ignoreAll", data)

// //-------------------短信模板---------------------
// // 获取模板分类
export const getTemplateType = params => get("shop/Template/getCateList", params)
// // 获取模板列表
export const getTemplateList = params => get("shop/Template/getList", params)
// // 创建自定义模板
export const createTemplate = data => post("shop/Template/add", data)
// // 生成短链接
export const createShortLink = data => post("shop/Template/createUrl", data)
// 删除自定义模板
export const delTemplate = data => post("shop/Template/delTemplate", data)
// 创建视频号短链接
export const getLink = data=>post("shop/Template/getLink",data)

// // ------------------会员----------------------
// // 获取会员列表
export const getCustomerList = params => get("shop/user/getList", params)
// // 筛选会员
export const screeningMembers = data => post("shop/Batch_Sender/appointUserTotal", data)
// // 添加黑名单
export const addBlackList = data => post("shop/User/addUserBlacklist", data)
// // 获取黑名单列表
export const getBlackList = params => get("shop/User/getUserBlacklist", params)

// // ------------------任务-----------------------
// // 修改任务状态
export const changeTask = data => post("shop/task/status", data)
// // 获取短信发送记录
export const getSmsSend = params => get("shop/Sms_log/getList", params)
// // 获取修改任务信息
export const getModifyTaskMsg = params => get("shop/task/getInfo", params)
// // 修改任务
export const ModifyTask = data => post("shop/Task/save", data)
// // 创建任务
export const createTask = data => post("shop/Task/add", data)
// // 删除任务
export const delTask = data => post("shop/task/del", data)
// // 获取每个环节任务列表
export const getTaskList = params => get("shop/task/getList", params)
// // 修改任务优先级
export const modifyTaskLevel = data => post("shop/task/sort", data)
// // 获取商品列表
export const getGoodsList = params => get("shop/Goods/getList", params)
// 获取选中商品列表
export const getChoiceGood = params => get("shop/Goods/getCheckList", params)
// 同步商品
export const refreshGoods = params => get("shop/Goods/syncGoods",params)
// // 催付效果分析
export const expeditingEffect = params => get("shop/Sms_log/getAnalysisList", params)
// 催评效果分析
export const commentEffect = params => get("shop/Sms_log/commentAnalysisList", params)
// 申请退款分析
export const requestRefund = params => get("shop/Sms_log/afterSalesAnalysisList",params)
// // 测试发送
export const testsend = data => post("shop/Send/testSend", data)
// 获取短信变量，签名集合
export const getVariable = params => get("shop/Template/getPropList", params)
// 获取初始模板
export const getInitTpl = params => get("shop/Template/getContent", params)
// 获取开启任务数
export const getTaskNum = params=>get("shop/Task/taskTypeCount",params)
// 获取任务配置
export const getTaskConfig = params => get("shop/Task/getTaskConfig",params)
// 修改任务配置
export const modifyTaskConfig = data => post("shop/Task/saveTaskConfig",data)
// 重新发送短信
export const resendSms = data => post("shop/Sms_log/reSend", data)
// 批量重新发送短信
export const batchResendSms = data => post("shop/Sms_log/reSends", data)
// 短信发送记录汇总统计
export const smsSendSummary = params => get("shop/Sms_log/getSmsSendSumData", params)

// // ------------------短信充值----------------------
// // 获取充值金额分类
export const getPayType = params => get("shop/pay/getList", params)
// // 获取充值记录列表
export const getRechargeList = params => get("shop/pay/getLogList", params)
// // 发起支付请求
export const payRequest = data => post("shop/pay/add", data)
// // 获取支付结果
export const payResult = params => get('shop/pay/checkIsPay', params)
// 获取自定义充值单价
export const getUnitPrice = params=>get("shop/pay/getCustomPrice",params)
// 创建自定义支付
export const customPay = data => post("shop/pay/addCustom", data)

// //-------------------订单---------------------
// // 获取订单列表
export const getOrderList = params => get("shop/order/getList", params)
// // 解码用户信息
export const decode = params => get("shop/order/decrypt", params)
// // 提交短信发送任务
export const submitSendTask = data => post("shop/Batch_Sender/sends", data)
// // 查询订单明细
export const queryOrderDetailed = params => get("shop/order/getOrderIdsList", params)
// // 获取指定订单的订单商品详情
export const getSkuList = params => get("shop/order/getItemInfo", params)
// 获取所有订单ID
export const getAllOrderId = params => get("shop/Batch_Sender/allOrder", params)
// 更新订单信息
export const updateOrder = data => post("shop/order/saveOrderInfo", data)
// 加入黑名单
export const addBlack = data => post("shop/Black_List/add", data)
// 获取黑名单列表
export const getBlackListMsg = params => get("shop/Black_List/getList", params)

// // -------------------群发---------------------
// // 导入号码群发
export const mobileSend = data => post("shop/Batch_Sender/appointMobile", data)
// // 获取群发任务列表
export const getGroupSendList = params => get("shop/Send/getList", params)
// 群发任务数据分析
export const sendDataAnalyse = data => post("shop/send/sendDataAnalysis", data,{timeout:180000})
// // 获取群发任务详情列表
export const getSendList = params => get("shop/Send/getSendLogList", params)
// 提交任务前判断短信是否充足
export const judge = data=>post("shop/Batch_Sender/createSendLog",data)

// // ---------------------人群-------------------
// // 通过标签预估人群数
export const estimatePeople = data => post("shop/User/crowdTotal", data)
// // 保存人群
export const holdCrowd = data => post("shop/User/addCrowd", data)
// // 获取人群列表
export const getCrowdList = params => get("shop/User/getCrowdList", params)
// // 创建人群短信发送任务
export const crowdMsgSend = data => post("shop/User/crowdMarketing", data)
// // 获取人群发送列表
export const getCrowdSendList = params => get("shop/Crowd/getCrowdLog", params)
// // 轮询修改发送状态
export const changeSentStatus = data => post("shop/Crowd/pollingCrowdLog", data)
// // 删除人群策略
export const delCrowd = data => post("shop/User/delCrowd", data)
// // 更新人群数量
export const upDateCrowdNum = data => post("shop/User/refreshCrowdCount", data)
// // 系统人群初始化创建
export const getSystemCrowd = data => get("shop/Crowd/addSysCrowd", data)

// // -----------------------个人中心----------------------------
// // 修改短信签名
export const changeLabel = data => post("shop/shop/addSign", data)
// // 短信签名修改记录
export const changeLabelRecord = params => get("shop/shop/getSignList", params)
// // 获取个人中心配置
export const getDispose = params => get("shop/shop/getShopConfig", params)
// // 保存软件到期和短信剩余提醒
export const remind = data => post("shop/shop/getShopConfig", data)
// 设置默认签名
export const setDefaultSign = data => post("shop/shop/saveDefaultSign", data)
// 获取签名报备内容
export const getSignReport = params => get("shop/shop/getSignReport", params)

// // -----------------公告-----------------
// // 获取公告详情
export const getDetails = params => get("shop/Home/getNoticeShow", params)

// -----------------评价列表------------------
// 获取评价详情
export const getEvaluateDetails = params => get("shop/Comment/getList", params)

//----------------多店铺绑定-----------------
// 获取绑定店铺信息
export const getBindShopMsg = params => get("shop/Multi/info", params)
// 绑定主店铺
export const bindMainShop = data => post("shop/Multi/addMain", data)
// 绑定子店铺
export const bindSubShop = data => post("shop/Multi/addSon", data)
// 多店铺绑定获取code
export const getShopCode = data => post("shop/Multi/getCode", data)
// 获取多店铺列表
export const getShopList = params => get("shop/Multi/shopSwitch", params)
// 切换店铺
export const switchShop = data => post("shop/Multi/shopuse", data)
// 移出子店铺
export const removeShop = data => post("shop/Multi/rmShop", data)
// 移出主店铺
export const removeBoosShop = data => post("shop/Multi/rmShops", data)

// -------------------发件人管理---------------------
// 获取发件人列表
export const getAddresserLiet = params => get("shop/task/getFromList", params)
// 新增发件人
export const addAddresser = data => post("shop/task/addFrom", data)
// 删除发件人
export const delAddresser = data => post("shop/task/delFrom", data)
// 修改发件人优先级
export const changeAddresserSort = data => post("shop/task/sortFrom", data)
// 获取短信回复记录
export const getReplyList = params => get("shop/Sms_log/getReplyList", params)

// -------------------数据分析---------------------------
// 地域下单分析
export const getAreaOrder = params => get("shop/Data_Analy/areaData", params)
// 商品销售分析
export const getGoodsSale = params => get("shop/Data_Analy/goodsSale", params)
// 今日分析数据
export const getTodayData = params => get("shop/Data_Analy/getTodayAnalysis", params)
// 获取订单趋势图数据
export const getOrderTourism = params => get("shop/Data_Analy/getTodayAnalysisTrend", params)
// 获取商品销量top7数据
export const getGoodsTop7 = params => get("shop/Data_Analy/getTodayAnalysisGoods", params)
// 获取今日新客/回头客数据
export const getNewConsumer = params => get("shop/Data_Analy/getTodayAnalysisNewUser", params)
// 获取订单成交数据
export const getOrderTransactionData = params=>get("shop/Data_Analy/orderTrade",params)
// 获取销售金额数据
export const getSaleAmountData = params => get("shop/Data_Analy/orderPrice", params)
// 获取订单流程分析数据
export const getOrderProcessing = params => get("shop/Data_Analy/orderFlow", params)
// 新老用户分析头部数据
export const getNewAndOldCustomers = params=>get("shop/Data_Analy/userData1",params)
// 新老用户每日成交量数据分析
export const getNewAndOldConsumertransactions = params=>get("shop/Data_Analy/userData2",params)
// 会员增长消费趋势分析
export const getMemberGrowth = params => get("shop/Data_Analy/userAddTrend", params)
// RFM数据分析
export const getRFMData = params => get("shop/Data_Analy/rfmData", params)

// =========================售后管理====================================
// 获取售后管理列表
export const getSaleAfter = params => get("shop/Order_Refund/index", params)
// 成功退款统计
export const getSaleAfterRefund = params => get("shop/Order_Refund/statisticsData", params)
// 成功退款原因分析
export const getSaleAfterRefundDetail = params => get("shop/Order_Refund/analysisData", params)
// 退款商品数据分析
export const getRefundGoods = params => get("shop/Order_Refund/statisticsGoods", params)

// =========================订单卡密====================================
// 获取订单卡密列表
export const getOrderCamiList = params => get('shop/Order_Code/getList', params)
// 获取卡密详情
export const getOrderCamiDetail = params => get('shop/Order_Code/getCodeList', params)
// 添加卡密
export const addOrderCami = data => post('shop/Order_Code/add', data)
// 补充卡密
export const supplyOrderCami = data => post('shop/Order_Code/addCode', data)
// 删除卡密
export const deleteOrderCami = data => post('shop/Order_Code/del', data)
// 获取商品SKU
export const getGoodsSku = params => get('shop/goods/getGoodsSkuList', params)
// 删除卡密内容
export const deleteOrderCamiContent = data => post('shop/Order_Code/delCode', data)
// 卡密使用记录
export const getOrderCamiRecord = params => get('shop/Order_Code/codeUseList', params)

// =========================视频号人群====================================
// 获取标签列表
export const getLabelList = params => get("shop/Crowd/getLabelList", params)
// 预估人群数量
export const countCrowdNumber = data => post("shop/Crowd/getAccurateUserAmount", data)
// 保存人群
export const saveCrowd = data => post("shop/Crowd/saveUserAudience", data)
// 跟新人群数
export const updateCrowdNumber = params => get("shop/Crowd/saveNumber", params)
// 人群发送短信
export const sendCrowdSms = data => post("shop/Crowd/send", data)
// 获取当前人群包签名
export const getCrowdSign = params => get("shop/Crowd/getSignName", params)
// 获取视频号人群营销记录
export const getTaskTransList = params => get("shop/Crowd/getTaskTransList", params)
// 获取任务转化数据
export const getTaskTransform = data => post("shop/Crowd/getTaskTransform", data)

// =========================账号密码====================================
// 修改账号密码
export const changeAccountPwd = data => post("shop/shop/saveAccountInfo", data)
// 账号密码登录
export const loginAccountPwd = data => post("shop/Login/loginByPwd", data)
// 获取账号密码
export const getAccountPwd = data => post("shop/shop/getAccountInfo", data)

// =========================更多工具====================================
// 获取更多工具列表
export const getMoreTools = params => get("shop/home/getPlatformList", params)

// =========================短信平台绑定====================================
// 获取平台列表
export const getPlatformList = params => get("shop/Bind/getPlatformList", params)
// 绑定平台店铺
export const bindPlatformShop = data => post("shop/Bind/add", data)
// 获取已绑定的平台店铺
export const getBindShop = params => get("shop/Bind/getList", params)
// 删除已绑定的平台店铺
export const delBindShop = data => post("shop/Bind/del", data)














































































































